import React from 'react';
import { Calendar } from 'lucide-react';
import {
  FORM_BORDER,
  FORM_BORDER_HOVER,
  FORM_BORDER_ERROR,
  FOCUS_RING,
  FOCUS_RING_ERROR,
  FORM_RADIUS,
  LABEL_TEXT,
  ERROR_TEXT,
} from './tokens';

interface DatePickerProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly label?: string;
  readonly placeholder?: string;
  readonly required?: boolean;
  readonly disabled?: boolean;
  readonly min?: string;
  readonly max?: string;
  readonly error?: string;
  readonly className?: string;
}

export const DatePicker: React.FC<DatePickerProps> = ({
  value,
  onChange,
  label,
  placeholder,
  required = false,
  disabled = false,
  min,
  max,
  error,
  className = ''
}) => {
  return (
    <div className={className}>
      {label && (
        <label className={`block ${LABEL_TEXT} mb-2`}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <div className="relative">
        <Calendar className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" />
        <input
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          min={min}
          max={max}
          className={`w-full pl-12 pr-4 py-3 ${FORM_RADIUS} transition-colors ${
            error
              ? `${FORM_BORDER_ERROR} ${FOCUS_RING_ERROR}`
              : `${FORM_BORDER} ${FORM_BORDER_HOVER} ${FOCUS_RING}`
          } ${disabled ? 'bg-slate-100 cursor-not-allowed' : 'bg-white'}`}
        />
      </div>

      {error && <p className={ERROR_TEXT}>{error}</p>}
    </div>
  );
};
